export enum RegistrationFlow {
  Application = "application",
  AdminInvite = "adminInvite",
  MemberInvite = "memberInvite",
  Invalid = "invalid",
}

export const getRegistrationFlow = (search: string): RegistrationFlow => {
  const params = new URLSearchParams(search);
  const token = params.get("token");

  if (!token) {
    return RegistrationFlow.Invalid;
  }

  if (params.get("application") === "true") {
    return RegistrationFlow.Application;
  }

  const adminInvite = params.get("admin_invite");
  if (adminInvite === "true") {
    return RegistrationFlow.AdminInvite;
  }
  if (adminInvite === "false") {
    return RegistrationFlow.MemberInvite;
  }

  return RegistrationFlow.Invalid;
};
